/**
 * Apply opacity to hex color by converting to rgba
 *
 * @param hexColor - Hex color (e.g., '#FA8C16')
 * @param opacityValue - Opacity 0-1 (e.g., 0.2, 0.15)
 * @returns rgba color string
 *
 * @example
 * withOpacity('#FA8C16', 0.2) // 'rgba(250, 140, 22, 0.2)'
 * withOpacity(colors.primary, opacity.medium) // 'rgba(250, 140, 22, 0.2)'
 */
export function withOpacity(hexColor: string, opacityValue: number): string {
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacityValue})`;
}
